import { Page, ProductSearchFilter, SelectSearchFilter, TranslatePagePayload } from '@app/_models/pages/page.model';

export class GetPageListAction {
    public static readonly type = '[SitePages] List pages';
    constructor(public idLang?: number) {}
}
export class CreatePage {
    public static readonly type = '[SitePages] CreatePage';
    constructor(public page: any) {}
}
export class CreateFolder {
    public static readonly type = '[SitePages] CreateFolder';
    constructor(public page: any) {}
}

export class CreateNewLink {
    public static readonly type = '[SitePages] CreateNewLink';
    constructor(public link: any) {}
}
export class DeletePageAction {
    public static readonly type = '[SitePages] Delete page';
    constructor(public id: number, public language: any) {}
}

export class DuplicatePageAction {
    public static readonly type = '[SitePages] Duplicate page';
    constructor(public id: any, public idLang: number) {}
}

export class ReorderPagesAction {
    public static readonly type = '[SitePages] ReorderPages';
    constructor(public pages: any, public language: number) {}
}

export class GetCategoriesForNewPage {
    public static readonly type = '[SitePages] Get categories for new page';
    constructor() {}
}

export class EditMode {
    public static readonly type = '[SitePages] EditMode';
    constructor() {}
}

export class DisableEditMode {
    public static readonly type = '[SitePages] DisableEditMode';
    constructor() {}
}
export class UpdatePageAction {
    public static readonly type = '[SitePages] UpdatePageAction';
    constructor(public page: any) {}
}

export class ReloadIframeUrl {
    public static readonly type = '[SitePages] ReloadIframeUrl';
    constructor() {}
}

export class ReloadIframeWithBaseUrl {
    public static readonly type = '[SitePages] ReloadIframeUrl';
    constructor() {}
}

export class UpdatePagePublicAccess {
    public static readonly type = '[SitePages] UpdatePagePublicAccess';
    constructor(public page: Page) {}
}

export class UpdatePageFunctionalityType {
    public static readonly type = '[SitePages] UpdatePageFunctionalityType';
    constructor(public page: Page) {}
}

export class SearchPosts {
    public static readonly type = '[SitePages] SearchPosts';
    constructor(public filter: SelectSearchFilter) {}
}

export class SearchBlogCategories {
    public static readonly type = '[SitePages] SearchBlogCategories';
    constructor(public filter: SelectSearchFilter) {}
}

export class SearchProducts {
    public static readonly type = '[SitePages] SearchProducts';
    constructor(public filter: ProductSearchFilter) {}
}

export class SearchProductsCategories {
    public static readonly type = '[SitePages] SearchProductsCategories';
    constructor() {}
}

export class GetSystemPageList {
    public static readonly type = '[SitePages] GetSystemPageList';
    constructor(public idLang?: number) {}
}

export class GetPredesignList {
    public static readonly type = '[SitePages] GetPredesignList';
    constructor(public type: string, public idLang: string) {}
}

export class SelectPredesign {
    public static readonly type = '[SitePages] SelectPredesign';
    constructor(public page: any) {}
}

export class TranslatePage {
    public static readonly type = '[SitePages] TranslatePage';
    constructor(public payload: TranslatePagePayload) {}
}
